import React from "react";
import { TIME_OF_REQUEST, TIME_SHEET } from "../../TimeSheetConstants";
import { TimeSheetTab } from "../TimesheetTab/TimeSheetTab";
import { TimeOffTab } from "../TimeOffTab/TimeOffTab";

const TimeSheetTabPanes = ({
  activeTab,
  handleApproveRejectClick,
  handleApproveRejectTimeOffClick,
  handlePageChange,
  page,
}) => {
  switch (activeTab) {
    case TIME_SHEET:
      return (
        <TimeSheetTab
        page={page}
          handleApproveRejectClick={handleApproveRejectClick}
          handlePageChange={handlePageChange}
        />
      );
    case TIME_OF_REQUEST:
      return (
        <>
          <TimeOffTab
        page={page}
            handleApproveRejectClick={handleApproveRejectTimeOffClick}
            handlePageChange={handlePageChange}
          />
        </>
      );
    default:
      return <></>;
  }
};

export { TimeSheetTabPanes };
